<div class="w-full relative min-w-0">
  <div class="relative w-full min-w-0">
    <!-- Single Select & Multi-Select (Custom Dropdown) -->
    <div [id]="displayId" (click)="toggleDropdown()" [class.opacity-60]="isDisabled"
      [class.cursor-not-allowed]="isDisabled" [class.is-open]="isOpen" [class.multi-select-dropdown]="isMultiple"
      [class.border-red-500]="hasError"
      class="dropdown-trigger w-full flex items-center px-3 py-2.5 text-[14px] border border-primary rounded-md text-primary bg-bg cursor-pointer relative h-[40px]">
      <div class="flex-1 min-w-0 relative flex items-center gap-2"
        [class.overflow-x-auto]="isMultiple" [class.overflow-hidden]="!isMultiple">
        <!-- Optional color swatch when option has commentColorCode (e.g. patient comment categories). -->
        <span *ngIf="!isMultiple && selectedCommentBackground"
          class="w-4 h-4 rounded border border-slate-300 flex-shrink-0"
          [style.background]="selectedCommentBackground">
        </span>
        <div class="flex-1 min-w-0 relative">
          <span *ngIf="hasValue"
            [class]="isMultiple ? 'block whitespace-nowrap font-semibold text-slate-800 z-20 relative text-[14px]' : 'block truncate font-semibold text-slate-800 w-full z-20 relative text-[14px]'">
            {{ getDisplayText() }}
          </span>
          <span *ngIf="!hasValue" [class.text-red-500]="isRequired"
            class="block truncate text-slate-400 z-20 relative text-[14px]">
            {{ getDisplayPlaceholder() }}
          </span>
        </div>
      </div>
      <div class="flex-shrink-0 ml-2 z-20 relative">
        <svg class="w-4 h-4 text-slate-400 transition-transform duration-300" [class.rotate-180]="isOpen" fill="none"
          stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      <label *ngIf="displayLabel" [for]="displayId" [class.floating-label-active]="isOpen || hasValue"
        [class.text-red-500]="isRequired" [class.text-muted]="!isRequired"
        class="floating-label absolute left-3 text-[13px] font-medium pointer-events-none transition-all duration-200">
        {{ displayLabel }}
        <span *ngIf="isRequired" class="text-red-500 ml-1">*</span>
      </label>
    </div>

    <!-- Dropdown Options (portaled to body when open — modal backdrop-filter breaks in-place fixed positioning) -->
    <div *ngIf="isOpen" #dropdownMenu [ngStyle]="dropdownStyle"
      class="bg-white border border-[#cfe8f7] rounded-xl shadow-2xl py-1.5 animate-in fade-in duration-200 dropdown-menu">
      <div *ngFor="let option of displayOptions" (click)="selectOption(option, $event)"
        class="group flex items-center justify-between px-4 py-2 text-[14px] hover:bg-[#f0f9ff] cursor-pointer transition-all border-l-2 border-transparent"
        [class.isSelected]="isSelected(option)" [class.border-secondary]="isSelected(option)"
        [class.bg-[#f0f9ff]]="isSelected(option)">
        <div class="flex items-center gap-2 flex-1 mr-2">
          <!-- Optional color swatch for options that include commentColorCode -->
          <span *ngIf="getCommentBackground(option) as bg"
            class="w-4 h-4 rounded border border-slate-300 flex-shrink-0"
            [style.background]="bg">
          </span>
          <span class="transition-colors flex-1"
            [class.text-secondary]="isSelected(option)"
            [class.font-semibold]="isSelected(option)"
            [class.text-slate-600]="!isSelected(option)">
            {{ option.label }}
          </span>
        </div>
        <div *ngIf="isSelected(option)" class="flex-shrink-0 text-secondary">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>
    </div>
  </div>
  <!-- Error messages should be handled by app-form-error-message component in the parent template -->
</div>